/**
 * Pharmacy-only PAF age warning (creation vs today), by patient type.
 * @param {object} pafItem — current PAF row
 * @param {{ isPharmacy: boolean }} ctx
 */
export function shouldShowPAFAgeWarningModal(pafItem, { isPharmacy }) {
  if (!isPharmacy || !pafItem?.pfa_issued) return false;

  const terminalStatuses = ["Approved", "Rejected", "Dispensed"];
  const status = pafItem?.status_name || pafItem?.status;
  if (terminalStatuses.includes(status)) return false;

  const pafCreationDate = new Date(pafItem.pfa_issued);
  if (Number.isNaN(pafCreationDate.getTime())) return false;

  const currentDate = new Date();
  const daysDifference = Math.floor(
    (currentDate - pafCreationDate) / (1000 * 60 * 60 * 24)
  );
  const weeksDifference = Math.floor(daysDifference / 7);

  const patientType = pafItem.patient?.patient_type;

  if (patientType === "Woman of Childbearing Potential") {
    return daysDifference >= 7;
  }

  if (
    patientType === "Male" ||
    patientType === "Woman of Non-Childbearing Potential"
  ) {
    return weeksDifference >= 12;
  }

  return false;
}
